var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1339 6.501L7.91683 11.7181L5.07475 8.88391L3.9585 10.0002L7.91683 13.9585L14.2502 7.62516L13.1339 6.501ZM9.50016 2.0835C5.13016 2.0835 1.5835 5.63016 1.5835 10.0002C1.5835 14.3702 5.13016 17.9168 9.50016 17.9168C13.8702 17.9168 17.4168 14.3702 17.4168 10.0002C17.4168 5.63016 13.8702 2.0835 9.50016 2.0835ZM9.50016 16.3335C6.001 16.3335 3.16683 13.4993 3.16683 10.0002C3.16683 6.501 6.001 3.66683 9.50016 3.66683C12.9993 3.66683 15.8335 6.501 15.8335 10.0002C15.8335 13.4993 12.9993 16.3335 9.50016 16.3335Z",
    fill: "#10B981"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/CheckCircleOutline.f7af22792f3e24532c746c83f1c9f798.svg";
export { ForwardRef as ReactComponent };